<div class="agpr-formField agpr-textField">
    <agpr-dropdown
        [id]="id + '_dropdown'"
        [options]="options"
        [placeholder]="field.placeholder"
        [ariaLabel]="ariaLabel"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onDropdownChanged($event.value)"
    ></agpr-dropdown>

    @if (showMessage) {
        <agpr-message
            class="agpr-topMentionsSortField-message"
            [severity]="messageSeverities.info"
        >
            {{ 'Reports.topMentions.sortField.custom.message' | localize }}
        </agpr-message>
    }
</div>